.wireframeWrapper {
	display: flex;
}

.wireframeTitle {
	display: inline-block;
	padding-left: var(--jpo-spacing);
}
